import {createModel} from "hox"
import {useBoolean} from "ahooks"
import {useRef} from "react"

function useScrollerStatus() {
    const [value, action] = useBoolean(false)

    const flagRef = useRef<ReturnType<typeof setTimeout>>()

    const setFalse = () => {
        flagRef.current = setTimeout(() => {
            action.setFalse()
        }, 1000)
    }

    const setTrue = () => {
        action.setTrue()
        if (flagRef.current != null) {
            clearTimeout(flagRef.current)
        }
        setFalse()
    }

    return {
        value,
        setTrue,
        setFalse,
    }
}

export default createModel(useScrollerStatus)
